export function flattenBreakdownData(res) {
  return _.flatten(res.map(res => {
    if (res.breakdown_data) {
      let {query} = res;
      return res.breakdown_data.map((data) => {return {data, query}});
    } else {
      return res;
    }
  }));
}

export function addMissingZeroDaysToResponse(res) {
  if (!res.data)
    return res; // no data

  if (!res.query.start_date && !res.query.end_date)
    return res; // no daterange

  let rows = res.data.rows;
  let startDate = moment.utc(res.query.start_date);
  let endDate = moment.utc(res.query.end_date);
  let rangeKeys = [];
  moment.range(startDate, endDate).by('days', d => rangeKeys.push(d.format('YYYY-MM-DD')));

  if (rows.length != rangeKeys.length) {
    // some missing rows
    let rowsKeys = _.map(rows, 'key');
    _.difference(rangeKeys, rowsKeys).forEach(missingKey => rows.push({key: missingKey, value: 0}));
    res.data.rows = _.sortBy(rows, 'key');
  }

  return res;
}

export function addMissingZeroDays(res) {
  return res.map(res => {
    return addMissingZeroDaysToResponse(res);
  });
}



/** WEBPACK FOOTER **
 ** ./src/common/analyticsPanel/chartResponse.js
 **/